.reviewContainer {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.submitButton {
    margin-left: auto;
}